export const initialValues = {
    name: '',
    description: '',
    image: '',
    icon: '',
    type: '',
    boon_id: 1
};

export const pictureAttributeNames = [
    "image",
    "icon"
];
